import { Injectable } from "@angular/core";
import { Service } from "../service.class";
import { Observable } from "rxjs";
import { PackModel } from "../../../shared/entities/pack.model";

@Injectable({
	providedIn: "root",
})
export class PacksService {
	private server_path: string = "/v2/packs";

	constructor(private service: Service) {}

	public postPackModel(f: PackModel): Observable<PackModel> {
		return this.service.apiPostWithoutHeaders(this.server_path, f);
	}
	public getPackModelById(id: string): Observable<PackModel> {
		return this.service.apiGetWithoutHeaders(this.server_path + "/" + id, {
			paginate: false,
		});
	}
	public deletePackModelById(id: string): Observable<PackModel> {
		return this.service.apiDelete(this.server_path + "/" + id);
	}
	public updatePackModelById(id: string, tool: PackModel): Observable<PackModel> {
		return this.service.apiPut(this.server_path + "/" + id, tool);
	}
}
